import { render } from "./UnitsAssignment.vue?vue&type=template&id=ee861756&scoped=true"
import script from "./UnitsAssignment.vue?vue&type=script&lang=js"
export * from "./UnitsAssignment.vue?vue&type=script&lang=js"

import "./UnitsAssignment.vue?vue&type=style&index=0&id=ee861756&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee861756"]])

export default __exports__